import type { SessionActor } from '../../core/auth';
import type { StoreDto } from '../stores/models/store.model';
import type { SupplierDto } from '../suppliers/models/supplier.model';
import type { InventoryUnitDto } from './models/inventory.model';

const isUnitMutable = (unit: InventoryUnitDto): boolean => unit.status !== 'SOLD';

export const resolveStoreName = (storeId: string, stores: StoreDto[]): string => {
  return stores.find((store) => store.id === storeId)?.name ?? storeId;
};

export const resolveSupplierName = (supplierId: string | null, suppliers: SupplierDto[]): string => {
  if (supplierId === null) {
    return 'Proveedor por defecto de la variante';
  }

  return suppliers.find((supplier) => supplier.id === supplierId)?.name ?? supplierId;
};

export const resolveOperationalActionVisibility = (actor: SessionActor | null, unit: InventoryUnitDto | null): boolean => {
  if (!actor || !unit) {
    return false;
  }

  if (!isUnitMutable(unit)) {
    return false;
  }

  return actor.role === 'STORE_ADMIN' || actor.role === 'SUPER_ADMIN';
};

export const requiresStatusTransitionReason = (
  currentStatus: InventoryUnitDto['status'] | null,
  nextStatus: InventoryUnitDto['status']
): boolean => currentStatus === 'MISSING' || nextStatus === 'MISSING';

export const resolveAllowedStatusTransitions = (
  status: InventoryUnitDto['status'] | null
): InventoryUnitDto['status'][] => {
  switch (status) {
    case 'AVAILABLE':
      return ['AVAILABLE', 'IN_REPAIR', 'MISSING', 'SOLD'];
    case 'IN_REPAIR':
      return ['IN_REPAIR', 'AVAILABLE', 'MISSING'];
    case 'MISSING':
      return ['MISSING', 'AVAILABLE'];
    case 'SOLD':
      return ['SOLD'];
    default:
      return ['AVAILABLE', 'IN_REPAIR', 'MISSING', 'SOLD'];
  }
};
